import Swal, { SweetAlertOptions } from "sweetalert2";
export const errorHandler = (error: any) => {
  const confirmButtonColor = "#2196f3";
  const swalError:SweetAlertOptions = { icon: "error", confirmButtonColor }
  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    switch (error.response.status) {
      case 400:
        error.response =
          "The request could not be understood by the server due to malformed syntax.";
        break;
      case 404:
        error.response =
          "The server has not found anything matching the requested path.";
        break;
      case 500:
        error.response =
          "The server encountered an unexpected condition which prevented it from fulfilling the request.";
        break;
      case 503:
        error.response =
          "The server is currently unable to handle the request due to a temporary overloading or maintenance of the server.";
        break;
      case 504:
        error.response =
          "The server did not get a response in time from the upstream server that it needed to complete the request";
        break;
    }
    Swal.fire({
      ...swalError,
      title: `Error ${error?.response?.status}`,
      text: error.response,
    });
  } else if (!error.response) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    Swal.fire({
      ...swalError,
      title: "Error (No Response)",
      text: "A request was made but no response was received.",
    });
  } else if (error.message) {
    // Something happened in setting up the request and triggered an Error
    Swal.fire({
      ...swalError,
      title: "Error",
      text: error.message?.toString(),
    });
  } else {
    Swal.fire({ ...swalError, title: "Error", text: "" });
  }
};
